import React, { useEffect, useRef, useState } from 'react'
import CircleLoader from '../../Loader/CircleLoader/CircleLoader';

import { RootState } from '../../../store';

import { useSelector } from 'react-redux';
import { IAoo, IField, IUser } from '../../../shared/interfaces';
import abilityBuild from '../../../shared/CASL/appAbility';
import { useBoolean } from '@fluentui/react-hooks';
import usersService from '../../../services/users.service';
import { Selection, CheckboxVisibility, DetailsList, Icon, DetailsListLayoutMode, SelectionMode, Text, EventGroup, IRenderFunction, IDetailsHeaderProps, IDetailsListStyles, StickyPositionType, Sticky, IColumn, DetailsHeader, mergeStyleSets, ContextualMenu, IContextualMenuItem, ContextualMenuItemType, TooltipHost } from '@fluentui/react';

const classNames = mergeStyleSets({
    emptyColumn: {

    },
});
export interface UsersManagerTableProps {
    forceTableRefresh?: boolean,
    readOnlyMode?: boolean,
    selectedUser?: IUser,
    userSelection: Selection,
    onSelectUsersManagerHandler?: (user: IUser | undefined) => void
    loadingUsersManagerTable?: boolean
    editUserManagerHandler?: () => void;
    deletetUserManagerHandler?: () => void;
}

type Props = UsersManagerTableProps;

const UsersManagerTable: React.FunctionComponent<Props> = (props) => {
    const selectCurrentAoo = (state: RootState) => state.sessionReducer.currentAoo;
    const currentAoo = useSelector(selectCurrentAoo);

    const selectIsMobile = (state: RootState) => state.sessionReducer.isMobile;
    const isMobile = useSelector(selectIsMobile);

    const [loadingUsersManagerTable, setLoadingUsersManagerTable] = useState<boolean>(false);

    const [tableColumns, setTableColumns] = useState<IColumn[] | undefined>([]);
    const [usersList, setUsersList] = useState<any[]>([]);

    const [showContextualMenu, setShowContextualMenu] = useState(false);
    const [contextMenuItems, setContextMenuItems] = useState<IContextualMenuItem[] | undefined>([]);
    const [contextMenuPosition, setContextMenuPosition] = useState<any>(undefined);


    useEffect(() => {
        setLoadingUsersManagerTable(props.loadingUsersManagerTable!);
    }, [props.loadingUsersManagerTable]);

    useEffect(() => {
        setColumns();
        getAllUsersManager();
    }, [currentAoo, props.forceTableRefresh]);

    useEffect(() => {
        const events = new EventGroup(undefined);
        events.on(props.userSelection, 'change', (ev) => {
            const selectedUser = props.userSelection.getSelection()[0] as IUser;
            if (props.onSelectUsersManagerHandler) {
                if (selectedUser) {
                    props.onSelectUsersManagerHandler(selectedUser);
                }
                else if (!selectedUser) {
                    props.onSelectUsersManagerHandler(undefined);
                }
            }
        });

        return () => {
            // Anything in here is fired on component unmount.
            events.dispose();
        }

    }, [usersList]);


    useEffect(() => {

    }, [props.selectedUser]);

    const getAllUsersManager = () => {
        if (currentAoo) {
            setLoadingUsersManagerTable(true);
            setUsersList([]);

            let getUsersManager;
            getUsersManager = usersService.getAllUsersInSelectedAoo(currentAoo.id);

            getUsersManager
                .then(usersList => {
                    setLoadingUsersManagerTable(false);
                    setUsersList(usersList);
                })
                .catch(error => {
                    setLoadingUsersManagerTable(false);
                    setUsersList([]);
                });
        }
    }

    const setColumns = () => {
        const fieldColumns = [

            {
                key: 'displayName',
                fieldName: 'displayName',
                name: 'Nome utente',
                minWidth: 100,
                maxWidth: 200,
                isResizable: true,
            },
            {
                key: 'isSuperAdmin',
                fieldName: 'isSuperAdmin',
                name: 'SuperAdmin',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'admin',
                fieldName: 'admin',
                name: 'Admin',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'supervisore',
                fieldName: 'supervisore',
                name: 'Supervisore',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'defaultAoo',
                fieldName: 'defaultAoo',
                name: 'Default Aoo',
                minWidth: 100,
                maxWidth: 150,
                isResizable: true,
            },
            {
                key: 'emailNotifica',
                fieldName: 'emailNotifica',
                name: 'Email di Notifica',
                minWidth: 100,
                isResizable: true,
            },


            //{
            //    key: 'notificaGiornaliera',
            //    fieldName: 'notificaGiornaliera',
            //    name: 'Notifica Giornaliera',
            //    minWidth: 100,
            //    maxWidth: 200,
            //    isResizable: true,
            //},
        ];
        /// Aggiungo una colonna vuota in coda alla tabella, è necessaria per consentire l'allineamneto tra
        /// l'header e i contenuti della tabella 
        if (isMobile == false) {
            fieldColumns.push(
                {
                    key: 'empty',
                    name: '',
                    fieldName: 'empty',
                    minWidth: 1,
                    maxWidth: 1,
                    isResizable: false
                },

            );
        }

        setTableColumns([...fieldColumns]);
    }


    const onRenderDetailsHeader = (detailsHeaderProps) => {
        const detailsListHeadrerStyles: Partial<IDetailsListStyles> = {

            root: { boxSizing: 'content-box !important' }

        };
        return (
            <DetailsHeader
                {...detailsHeaderProps}
                styles={detailsListHeadrerStyles}
            />
        );
    }

    const onRenderItemColumn = (item?: IUser, index?: number | undefined, column?) => {
        if (item) {
            const fieldContent = item[column.fieldName];

            switch (column.fieldName) {
                case 'isSuperAdmin':
                    if (item!.isSuperAdmin) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'admin':
                    if (usersService.userIsAdmin(item!, currentAoo!.id)) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'supervisore':
                    if (usersService.userIsSupervisore(item!, currentAoo!.id)) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'notificaGiornaliera':
                    const notificaGiornaliera = fieldContent;
                    if (notificaGiornaliera) {
                        return <span><Icon iconName={"CheckMark"} style={{ color: 'green', fontSize: '15px', fontWeight: 'bold' }} /></span>
                    }
                    else {
                        return <span></span>
                    }
                case 'defaultAoo':
                    const defaultAoo = (fieldContent as IAoo);
                    if (defaultAoo) {
                        return <TooltipHost content={defaultAoo.name} id={`tooltip_${defaultAoo.name}`} >
                            <span className="text-overflow-ellipsis">{defaultAoo.name}</span>
                        </TooltipHost>
                    } else {
                        return <span></span>
                    }
                default:
                    return <TooltipHost content={fieldContent} id={`tooltip_${fieldContent}`} >
                        <span className="text-overflow-ellipsis">{fieldContent}</span>
                    </TooltipHost>
            }
        }
    }

    // metodi gestione context menu 
    const onShowContextualMenu = (item, index, ev) => {
        ev.preventDefault();

        updateContextMenuUsersManager();
        setShowContextualMenu(true);
        setContextMenuPosition(ev);

    };

    const updateContextMenuUsersManager = () => {
        const menuItems: IContextualMenuItem[] = [];

        if (abilityBuild.can('update', 'IUser')) {
            menuItems.push(
                {
                    key: 'editUser',
                    text: 'Modifica utente',
                    iconProps: { iconName: 'EditContact' },
                    onClick: () => {
                        props.editUserManagerHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        if (abilityBuild.can('delete', 'IUser')) {
            menuItems.push(
                {
                    key: 'deleteUser',
                    text: 'Elimina utente',
                    iconProps: { iconName: 'UserRemove' },
                    onClick: () => {
                        props.deletetUserManagerHandler!();
                        onHideContextualMenu();
                    }
                }
            )
        }
        setContextMenuItems(menuItems);
    }

    const onHideContextualMenu = () => {
        setShowContextualMenu(false);
        setContextMenuItems(undefined);
    };

    return (
        <React.Fragment>
            <CircleLoader loaderClass='loader-large' loading={loadingUsersManagerTable} />

            {/* <div className={`my-component-content`}>*/}

            {
                usersList && usersList.length > 0
                    ? <DetailsList
                        className="with-empty-column"
                        items={usersList}
                        columns={tableColumns}
                        layoutMode={DetailsListLayoutMode.justified}
                        onRenderDetailsHeader={onRenderDetailsHeader}
                        onRenderItemColumn={onRenderItemColumn}
                        selection={props.userSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={SelectionMode.single}
                        checkboxVisibility={CheckboxVisibility.onHover}
                        onItemContextMenu={onShowContextualMenu}
                    />
                    : <div style={{ marginLeft: '31px' }}>
                        <Text> Nessun utente inserito</Text>
                    </div>
            }

            <ContextualMenu
                items={contextMenuItems!}
                hidden={!showContextualMenu}
                target={contextMenuPosition}
                onItemClick={onHideContextualMenu}
                onDismiss={onHideContextualMenu}
            />

            {/*  </div>*/}

        </React.Fragment>
    )
}
export default UsersManagerTable;
